/**
 * OPS-19: Pipeline diagnostics client hook.
 * Records per-stage timing for V3 and Demo pipelines. Non-blocking: never throws.
 * Uses static supabase client so diagnostics never affect the critical path (no dynamic import).
 */

import { supabase } from '@/integrations/supabase/client';

export type PipelineType = 'v3' | 'demo';

export interface DiagnosticEvent {
  runId: string;
  pipelineType: PipelineType;
  stage: string;
  clientRecordedAt: string; // ISO timestamp
  meta?: Record<string, unknown>;
}

export function usePipelineDiagnostics() {
  const recordStage = (event: DiagnosticEvent) => {
    (async () => {
      try {
        await supabase.from('pipeline_diagnostics').insert({
          run_id: event.runId,
          pipeline_type: event.pipelineType,
          stage: event.stage,
          client_recorded_at: event.clientRecordedAt,
          meta: event.meta ?? {},
        });
      } catch (error) {
        console.warn('[Diagnostics] Failed to record stage:', event.stage, error);
      }
    })();
  };

  return { recordStage };
}
